export const RefreshStatus = ({ loading, error, updatedAt, prefix }) => <div
  className="h-10 flex items-center text-xs leading-5 min-w-0"
  data-testid={`${prefix}-refresh-status`} aria-live="polite" aria-atomic="true">
  {error ? <p className="text-red-800" role="alert" title={error} data-testid={`${prefix}-refresh-error`}>Actualisation impossible. Les données affichées sont conservées.</p>
    : <p className="text-slate-500" data-testid={`${prefix}-refreshing`}>{loading ? 'Actualisation…'
      : updatedAt ? `À jour à ${new Date(updatedAt).toLocaleTimeString('fr-FR')}` : ''}</p>}
</div>;